export const EmptyState = ({ icon: Icon, title, description, badge, action, testId = "empty-state" }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-[#E5E7EB] bg-white px-6 py-12 text-center sm:py-16">
    {Icon && (
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#000B45] text-[#FEB601]">
        <Icon className="h-7 w-7" />
      </div>
    )}
    {badge && (
      <span data-testid="module-coming-soon-badge" className="mb-3 inline-block rounded-full bg-[#FEB601]/15 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#8a6300]">
        {badge}
      </span>
    )}
    <h2 className="font-display text-lg font-bold text-[#000B45] sm:text-xl">{title}</h2>
    {description && <p className="mx-auto mt-2 max-w-md text-sm text-gray-600 sm:text-base">{description}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
